<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm y menores: -->
        <v-navigation-drawer
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
            v-if="isAuthenticated"
        >
            <v-list v-if="isAuthenticated" dense class="pt-0">

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onUsers"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-account-multiple</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Usuarios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="(userType === 1)" class="tw-green" @click="onIdiomas">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-earth</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Idiomas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item
                    v-if="userType === 1"
                     @click="onCuestionarios"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-clipboard-list-outline</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                         <v-list-item-title>Casos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onEncuestas"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-clipboard-search-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Encuestas</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onNuevaEncuesta"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-clipboard-plus-outline</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Nueva Encuesta</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                    class="tw-green"
                    @click="onLogout"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Salir</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm y menores-->

        <v-app-bar flat fixed app color="grey lighten-5" clipped-left>
            <v-app-bar-nav-icon
                class="hidden-md-and-up"
                @click="drawer = !drawer"
                v-if="isAuthenticated"
            ></v-app-bar-nav-icon>

            <img
                height="55"
                :src="mainLogo"
                @click="onHome"
                class="logo-hover"
            />

            <v-toolbar-title
                v-if="isAuthenticated && userType === 1"
                class="hidden-sm-and-down"
            >
                <div class="tw-green title">&nbsp; {{ userName }}</div>
            </v-toolbar-title>
            <v-toolbar-title
                v-else-if="
                    isAuthenticated &&
                    (userType === 1 || userType === 2)
                "
                class="hidden-sm-and-down"
            >
                <div class="tw-green title">
                    {{ userName }}
                </div>
            </v-toolbar-title>

            <v-toolbar-title
                v-if="isAuthenticated && userType === 1"
                class="hidden-md-and-up"
            >
                <div class="tw-green subtitle-1">{{ userName }}</div>
            </v-toolbar-title>
            <v-toolbar-title
                v-if="isAuthenticated && userType !== 1"
                class="hidden-md-and-up"
            >
                <div class="tw-green subtitle-1">
                    {{ userName }}
                </div>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items v-if="isAuthenticated" class="hidden-sm-and-down">
                <v-menu v-if="userType === 1" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="teal darken-3"
                            text
                            class="text-none"
                            v-on="on">
                            <v-icon color="teal darken-1">mdi-cog</v-icon>&nbsp;Administración
                        </v-btn>
                    </template>
                    <v-list color="grey lighten-5">
                        <v-list-item v-if="userType === 1" @click="onUsers">
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-account-multiple</v-icon
                                >&nbsp; Usuarios
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="(userType === 1)" @click="onIdiomas">
                            <v-list-item-title>
                                <v-icon color="teal darken-1">mdi-earth</v-icon>&nbsp; Idiomas
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userType === 1"
                            @click="onCuestionarios"
                        >
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-clipboard-list-outline</v-icon
                                >&nbsp; Casos
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    v-if="userType === 1"
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onEncuestas">
                    <v-icon color="teal darken-1">mdi-clipboard-search-outline</v-icon>&nbsp;Encuestas
                </v-btn>
                <v-btn
                    v-if="userType === 1"
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onNuevaEncuesta">
                    <v-icon color="teal darken-1">mdi-clipboard-plus-outline</v-icon>&nbsp;Nueva Encuesta</v-btn
                >
                <v-btn
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onLogout"
                    >Salir</v-btn
                >
            </v-toolbar-items>
            <!-- Fin del menú visible si se inició sesión -->

            <!-- El select para cambiar idioma aparece si no se está logueado o si el usuario logueado no es encuestado: -->
            <!-- <v-toolbar-items
                v-if="!isAuthenticated || (isAuthenticated && userType !== 4)"
            >
                <locale-changer></locale-changer>
            </v-toolbar-items> -->

            <img
                height="65"
                :src="inteligenciaEjecutivaLogo"
                @click="onHome"
                class="logo-hover"
            />
        </v-app-bar>

        <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            //valid: false
            //     e1: true,
            //     password: '',
            //     passwordRules: [v => !!v || 'Introduzca la contraseña'],
            //     email: '',
            //     emailRules: [
            //         v => !!v || 'Introduzca su correo electrónico',
            //         v =>
            //             /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            //             'Introduzca un correo válido'
            //     ],
        };
    },
    components: {
        LocaleChanger,
    },
    methods: {
        onHome() {
            if (!this.isAuthenticated) {
                this.drawer = false;
            }
        },
        onUsers() {
            this.$router.push('/users');
            this.drawer = false;
        },
         onIdiomas() {
            this.$router.push('/languages');
            this.drawer = false;
        },
        onCuestionarios() {
            this.$router.push('/questionnaires');
            this.drawer = false;
        },
        onEncuestas() {
            this.$store.dispatch('fetchSurveys');
            this.drawer = false;
        },
        onLogout() {
            //console.log('logout');
            //this.overlay = true;
            this.$store.dispatch('logout');
            this.drawer = false;
        },
        onNuevaEncuesta() {
            this.$router.push('/newsurvey').catch(err => {});
            this.drawer = false;
        },
    },
    computed: {
        ...mapGetters([
            'appTitle',
            'mainLogo',
            'mainLogoAppBar',
            'inteligenciaEjecutivaLogo',
            'isAuthenticated',
            'userName',
            'userType',
        ]),
    },
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}

.logo-hover:hover {
    cursor: pointer;
}

.usr-name {
    font-size: 14px;
    color: #00897b;
}

.tw-green {
    color: #00897b;
}

.tw-gray {
    /* color: #757575; */
    /* grey darken-1 */
    color: red;
}
</style>
